import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCookie } from "typescript-cookie";
import { ISelectOption } from "../../models/utils/selectOption";
import { defaultFilterOption } from "../../utils";
import { useGetDataOnScroll } from "../getDataOnScrollProps/useGetDataOnScrollProps";
import { EntDirectoryInfoName } from "../../models/directoryInfoName";
import { EntInitialFilterName } from "../../models/filters/initialFilterName";
import { useLazyGetOwnershipTypesListQuery } from "../../redux/api/handBooksApi/ownershipTypesApi";

interface IProps {
    value?: number | null;
    onChange?: (e: any, a: any) => void;
    disabled?: boolean;
}

const SelectOwnerShipTypes = (props: IProps) => {
    const { t } = useTranslation();
    const [options, setOptions] = useState<ISelectOption[]>([]);

    const [getData] = useLazyGetOwnershipTypesListQuery();
    const {
        fetching,
        data,
        setData,
        setFetching,
        setFilter,
        scrollHandler,
        setCurrentPage
    } = useGetDataOnScroll<EntDirectoryInfoName, EntInitialFilterName>({
        initialFilter: new EntInitialFilterName(),
        query: getData
    });

    useEffect(() => {
        const options = Array.from(new Set(data)).map((a) => {
            return { label: getCookie('i18next') === 'ky' ? `${ a.nameKy }` : `${ a.nameRu }`, value: a.id ?? '' };
        });
        setOptions(options);
    }, [data]);

    const search = (value?: string) => {
        if (!value) return;
        const filter = new EntInitialFilterName();
        filter.name = value;
        setFilter(filter);
        setData([]);
        setCurrentPage(0);
        setFetching(true);
    }
    const clear = () => {
        const filter = new EntInitialFilterName();
        filter.name = null;
        setFilter(filter);
        setData([]);
        setCurrentPage(0);
        setFetching(true);
    }

    return (
        <Select
            disabled={ props.disabled }
            placeholder={ t("msg.selectPlaceholder") }
            onClear={ clear }
            onSearch={ search }
            onPopupScroll={ scrollHandler }
            loading={ fetching }
            value={ props.value }
            onChange={ props.onChange }
            options={ options }
            filterOption={ defaultFilterOption }
            showSearch
            allowClear
            dropdownRender={ (menu) => (
                <Spin spinning={ fetching }>
                    { menu }
                </Spin>
            ) }
        />
    );
};

export default SelectOwnerShipTypes;